<template>
  <span :class="`${textLength > maxText && 'tw-text-red-500'}`">
    {{`(${textLength}/${maxText})`}}
  </span>
</template>
<script>
export default {
  props:{
    text: {
      required:true
    },
    maxText: {
      requred:true,
      type:Number
    }
  },
  computed: {
    textLength() {
      let rs = 0
      if (this.text) {
        rs = this.text.length 
      }
      return rs
    }
  }
  
}
</script>